module.exports = __webpack_public_path__ + "img/stackslash-76-mobile.4299408b.jpg";